import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrReorder202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_reorder_202605",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 63686,
  clicks: 834,
  adsSpendDollars: 6039,
  budgetDollars: 9000,
  salesDollars: 27565,
  bestEstimateRoas: 4.56,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.67,
  reorderConversions: 105,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
